var map = {
	"./bob.png": 5060,
	"./dawn.png": 8251,
	"./design.svg": 8483,
	"./development.svg": 1732,
	"./discus.png": 7840,
	"./email.svg": 822,
	"./facebook.svg": 3536,
	"./github.svg": 6002,
	"./lewis.png": 224,
	"./linkedin.svg": 7657,
	"./logo.png": 4427,
	"./maintenance.svg": 122,
	"./makemybeer.png": 3374,
	"./marker.svg": 4616,
	"./matt.png": 102,
	"./message.svg": 2525,
	"./name.svg": 7122,
	"./pfsolutions.png": 3810,
	"./portfolio.png": 718,
	"./solar.png": 9196,
	"./subject.svg": 9619,
	"./tft.png": 3275,
	"./tim.png": 1976,
	"./trinity.png": 5043,
	"./twitter.svg": 7751,
	"./wave.svg": 3599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4081;